import { Localized } from "@fluent/react";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

interface LogoutUIProps {
	handleClick: () => void;
}

export default function LogoutUI(props: LogoutUIProps) {

	return (
		<>
			<ListItem button onClick={() => props.handleClick()}>
				<ListItemIcon>
					<LogoutIcon />
				</ListItemIcon>
				<Localized id="logout-buton" attrs={{ primary: true }}>
					<ListItemText />
				</Localized>
			</ListItem>
		</>
	);
}
